import { currencies } from '../../constants/Currencies';

export const getCurrencySymbol = (currencyCode?: string): string => {
  const currency = currencies.find(item => item.code === currencyCode);

  return currency?.symbol || currencyCode || '';
};

export const formatMoney = (
  amount: string | number | null | undefined,
  currencyCode?: string | null,
): string => {
  const symbol = getCurrencySymbol(currencyCode || undefined);

  if (amount === null || amount === undefined) {
    return `0.00 ${symbol}`.trim();
  }

  const numericAmount = Number(amount);

  if (Number.isNaN(numericAmount)) {
    return `${amount} ${symbol}`.trim();
  }

  return `${numericAmount.toFixed(2)} ${symbol}`.trim();
};
